var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field", class: { "field--error": _vm.error } },
    [
      _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
      _c(
        "div",
        { staticClass: "control" },
        [
          _vm._t("default"),
          !_vm.required
            ? _c(
                "p",
                {
                  staticClass: "help is-danger",
                  attrs: { "data-test": _vm.testName },
                },
                [_vm._v(" " + _vm._s(_vm.label) + " is required ")]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }